import { render, staticRenderFns } from "./v-menu-item.vue?vue&type=template&id=4c8cd86f&scoped=true"
import script from "./v-menu-item.vue?vue&type=script&lang=js"
export * from "./v-menu-item.vue?vue&type=script&lang=js"
import style0 from "./v-menu-item.vue?vue&type=style&index=0&id=4c8cd86f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8cd86f",
  null
  
)

export default component.exports